<template lang="pug">
  el-form#custom-content(
    :model="formAnswer"
    :rules="rules"
    ref="formAnswer")

    el-row(:gutter="20" style="margin: 2%;")
      el-col(:span="24" style="display: flex; flex-direction: row; justify-content: flex-start; flex-wrap: wrap;")
        // Answer
        el-badge(
          :value="badgeValue"
          :type="badgeType"
          :hidden="hideBadge"
        )
          el-form-item(prop="answer")
            codemirror(
              class="codemirror"
              v-model="formAnswer.answer"
              :options="cmOptions"
            )
    el-row(v-if="!isGraded && results.length > 0")
      div(
        v-for="(testcase, index) in results"
        :key="index"
        class="results-table"
      )
        template(v-if="!isCorrect && testcase.error && testcase.error.length > 0")
          h4 Error
          p(style="color: red") {{ testcase.error }}
        i(class="el-icon-notebook-2 results-header" style="font-size: 1.25em")
        span(class="results-header") Test Case {{ index + 1 }}
        div.margin-top-15(v-for="(value, key) in testcase")
          h5(
            class="results-header"
            v-if="key !== 'error' && value.length > 0"
            capitalize
          ) {{ formatCriteria(key)}}
          el-table(
            v-if="key !== 'error' && value.length > 0"
            :data="value.filter(v => v.name)"
            :row-class-name="rowFormatter"
          )
            el-table-column(
              align="center"
              prop="name"
              label="Criteria"
            )
            el-table-column(
              align="center"
              prop="expectedResult"
              label="Expected result"
              :formatter="dataFormatter"
            )
            el-table-column(
              align="center"
              prop="studentAnswer"
              label="Student answer"
              :formatter="dataFormatter"
            )
            el-table-column(
              align="center"
              prop="correct"
              label="Correct?"
              :formatter="dataFormatter"
            )
    // Buttons
    el-row(:gutter="20" style="margin: 2%;")
      el-col(:span="24" style="display: flex; flex-direction: row; justify-content: flex-start; flex-wrap: wrap; align-items: baseline;")
        el-button-group(style="margin: 30px 15px 0 0")
            el-button(
              icon="el-icon-error"
              :loading="processing"
              :disabled="finished"
              @click="clearForm")
                small Clear
            el-button(
              type="primary"
              icon="el-icon-document"
              :loading="processing"
              :disabled="finished"
              @click="onSubmitValidate('formAnswer')")
                small Submit

</template>

<script>
  import utilMixin from '@/components/mixins/utilMixin'
  import { codemirror } from 'vue-codemirror'
  import 'codemirror/mode/octave/octave'

  export default {
    name: 'CodingView', 

    components: {
      codemirror,
    },

    mixins: [utilMixin],

    props: {
      questionData: {
        type: Object,
        required: true,
      },
      isGraded: {
        type: Boolean,
        required: true,
      },
    },

    data() {
      return {
        hideBadge: true,
        badgeType: 'success',
        badgeValue: '✓',
        formAnswer: {
          answer: '',
        },
        rules: {
          answer: [
            { required: true, message: 'Please type your answer.', trigger: 'blur' },
          ],
        },
        processing: false,
        finished: false,
        isCorrect: false,
        results: [],

        cmOptions: {
          mode: 'text/x-octave',
          lineNumbers: true,
          line: true,
        },
      }
    },

    watch: {
      questionData() {
        this.clearForm()
        this.finished = false
      },
    },

    mounted() {
    },  

    methods: {
      onSubmitValidate(formName) {
        this.hideBadge = true
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.processing = true
            this.axios.post('/api/quiz/' + this.$store.state.quizData.id + '/question/' + this.questionData.id + '/check', {
              answer: this.formAnswer.answer,
            })
              .then(({ data }) => {
                this.$emit('questionSubmitted', {
                  id: this.questionData.id,
                  score: data.score,
                })
                this.hideBadge = false
                this.isCorrect = data.score >= this.questionData.score
                if (this.isCorrect) {
                  this.badgeType = 'success'
                  this.badgeValue = '✔'
                } else {
                  this.badgeType = 'danger'
                  this.badgeValue = '✘'
                }
                this.processing = false
                this.$set(this, 'results', data.results)
                this.finished = this.isGraded
              })
              .catch((error) => {
                this.processing = false
                this.mNotification( {error: error, message: 'There was an error checking your answer.'} )
              })
          } else {
            return false
          }
        })
      },

      clearForm() {
        this.$refs.formAnswer.resetFields()
        this.$set(this, 'isCorrect', false)
        this.$set(this, 'results', [])
        this.hideBadge = true
        this.processing = false
      },

      formatCriteria(key) {
        const fm = {
          varName: 'Variable Name',
          varType: 'Variable Type',
          varValue: 'Value',
          fileName: 'File Name',
          graph: 'Graph',
        }
        return fm[key]
      },

      rowFormatter({ row }) {
        return row.correct ? '' : 'incorrect-row'
      },

      dataFormatter(row, col, dataValue) {
        if (typeof dataValue === 'boolean') return dataValue.toString()
        return !dataValue || dataValue.length === 0
          ? ''
          : dataValue
      },
    },
  }
</script>

<style scoped>
  .codemirror {
    border: 1px solid #888;
    width: 70vw;
    font-size: 1.1em;
    line-height: 2em;
  }

  .results-table {
    margin: 0px 20px 0px 20px;
  }

  .results-header {
    color: #616161;
    margin-right: 5px;
    font-size: 0.9em;
    line-height: 1.25em;
  }
</style>

<style>
  .CodeMirror-lines {
    font-family: 'Courier New', Courier, monospace !important;
  }

  .el-table .incorrect-row {
    background: #ffebee;
  }
</style>